export const percentageFinder = (high, low, target) => {
    let totalDiffernce = Number(high) - Number(low);
    let newTarget = Number(target) - Number(low);
    return (newTarget * 100) / totalDiffernce;
};
export function getPercentage(baseValue, curValue) {
    if (baseValue && curValue) {
        return (Number(curValue) / Number(baseValue)) * 100;
    }
    return;
}
